export default "__VITE_ASSET__CT9CsY$9__"